import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "semantic-ui-react";
import { yup } from "utils";

import Form from "components/Form";
import Modal from "components/Modal";

export function AddNewHubForm({ onSubmit, loading, onClose }) {
  const { setFocus, ...formProps } = useForm({
    mode: "onSubmit",
    defaultValues: { name: "" },
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("Please provide name to the new Hub"),
      })
    ),
  });

  useEffect(() => {
    setFocus("name");
  }, [setFocus]);

  return (
    <Modal isModalOpen size="mini" onClose={onClose} data-test="new-hub-modal">
      <Modal.Header onClose={onClose}>Add New Hub</Modal.Header>
      <Modal.Body>
        <Form
          id="hubForm"
          {...formProps}
          onSubmit={({ name }) => {
            return onSubmit(name);
          }}
        >
          <Form.Input
            name="name"
            label="Name"
            fluid
            required
            disabled={loading}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          content="Discard Changes"
          basic
          onClick={onClose}
          disabled={loading}
        />
        <Button
          primary
          content="Create"
          type="submit"
          form="hubForm"
          loading={loading}
          disabled={loading}
        />
      </Modal.Footer>
    </Modal>
  );
}

AddNewHubForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

AddNewHubForm.defaultProps = {
  loading: false,
};

export default AddNewHubForm;
